module.exports = __webpack_public_path__ + "static/news68.png";